import Select from 'react-select';
import { theme } from 'tailwind.config';
function CategoriesSelectBox({
    options,
    cssClassName,
    onChange,
    defaultValue,
}) {
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: 'none',
            borderRadius: '20px',
            border: 0,
            color: theme?.colors?.primary?.[500],
            width: '100%',
            height: '40px',
            fontSize: '14px',
            cursor: 'pointer',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: 'none',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            cursor: 'pointer',
            size: '13px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '10px',
        }),
        option: (provided) => ({
            ...provided,
            borderRadius: '10px',
            cursor: 'pointer',
        }),
        menuList: (provided) => ({
            ...provided,
            '::-webkit-scrollbar': {
                width: '0px',
                height: '0px',
            },
        }),
    };

    return (
        <Select
            instanceId="categoriesSelectBox"
            className={cssClassName}
            options={options}
            styles={customStyles}
            onChange={onChange}
            defaultValue={defaultValue}
            isSearchable={false}
        />
    );
}

export default CategoriesSelectBox;
